import { render, staticRenderFns } from "./TemplateGroupTemplates.vue?vue&type=template&id=0e180eb8&scoped=true&"
import script from "./TemplateGroupTemplates.vue?vue&type=script&lang=js&"
export * from "./TemplateGroupTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGroupTemplates.vue?vue&type=style&index=0&id=0e180eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e180eb8",
  null
  
)

export default component.exports